import { login } from "../stores";
import { config } from "../config";
import { RepositoryResponse } from "../model/repositoryResponse";
import { navigate } from "svelte-navigator";
import { LocalStorage } from "./localStorage";
import dayjs from "dayjs";
export class Repository {
    constructor() {
        this.currentToken = "";
        this.baseUrl = "";
        this.fetchErrorCode = 500;
        this.baseUrl = config.baseUrl;
        let expire = LocalStorage.getSessionExpire();
        let user = LocalStorage.getUserStorage();
        if (user && expire) {
            if (dayjs().isAfter(dayjs(expire))) {
                this.logOut();
            }
            else {
                let existingToken = user.token;
                this.currentToken = existingToken;
                login.isLogin.set(true);
            }
        }
        else {
            this.logOut();
        }
    }
    async baseRequest(method, url, body) {
        let expire = LocalStorage.getSessionExpire();
        if (dayjs().isAfter(dayjs(expire))) {
            this.logOut();
            return null;
        }
        else {
            try {
                let response = await fetch(this.baseUrl.concat(url), {
                    method: method,
                    headers: {
                        "Content-type": "application/json",
                        "X-Api-Key": this.currentToken
                    },
                    body: JSON.stringify(body)
                });
                return response;
            }
            catch (e) {
                console.error(e);
                return null;
            }
        }
    }
    async logIn(credentials) {
        let url = "admin/login";
        let response = await this.baseRequest("POST", url, credentials);
        if (response != null) {
            let jsonResponse = await response.json();
            if (jsonResponse.success) {
                LocalStorage.setUserStorage(jsonResponse.data);
                LocalStorage.setSessionExpire();
                this.currentToken = jsonResponse.data.token;
                login.isLogin.set(true);
            }
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
    logOut() {
        login.isLogin.set(false);
        LocalStorage.reset();
        navigate("/");
        return true;
    }
    // TEMPLATES
    async getTemplates() {
        let url = "templates";
        let response = await this.baseRequest("GET", url);
        if (response != null) {
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
    async getTemplate(templateUuid) {
        let url = "templates/" + templateUuid;
        let response = await this.baseRequest("GET", url);
        if (response != null) {
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
    async createTemplate(newTemplate) {
        let url = "templates";
        let response = await this.baseRequest("POST", url, newTemplate);
        if (response != null) {
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
    async updateTemplate(updatedTemplate) {
        let url = "templates/" + updatedTemplate.uuid;
        let response = await this.baseRequest("PUT", url, updatedTemplate);
        if (response != null) {
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
    async uploadTemplate(file, uuid) {
        let array = [];
        array.push(file);
        let formData = new FormData();
        let url = this.baseUrl + "templates/file/" + uuid;
        formData.append("fileToUpload", file);
        try {
            let response = await fetch(url, {
                method: "POST",
                headers: {
                    "X-Api-Key": this.currentToken,
                },
                body: formData
            });
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        catch (e) {
            console.error(e);
            return new RepositoryResponse(false, 400, null, null, null);
        }
    }
    async deleteTemplate(templateUuid) {
        let url = "templates/" + templateUuid;
        let response = await this.baseRequest("DELETE", url);
        if (response != null) {
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
    // END
    // INDEMNITIES
    async getIndemnities(offset, limit, orderByField, orderDirection) {
        let url = "indemnities";
        if (offset != null && limit != null) {
            url = url + "?offset=" + offset + "&limit=" + limit;
            if (orderByField != null && orderDirection != null) {
                url = url + "&field=" + orderByField + "&direction=" + orderDirection;
            }
        }
        let response = await this.baseRequest("GET", url);
        if (response != null) {
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
    async getActiveIndemnityInDatesRange(startDate, endDate, nasid) {
        let url = "indemnities/active?startDate=" + startDate + "&endDate=" + endDate;
        if (nasid != null && nasid != "") {
            url = url + "&nasid=" + nasid;
        }
        let response = await this.baseRequest("GET", url);
        if (response != null) {
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
    async getIndemnity(indemnityUuid) {
        let url = "indemnities/" + indemnityUuid;
        let response = await this.baseRequest("GET", url);
        if (response != null) {
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
    async createIndemnity(newIndemnity) {
        let url = "indemnities";
        let response = await this.baseRequest("POST", url, newIndemnity);
        if (response != null) {
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
    async updateIndemnity(updatedIndemnity) {
        let url = "indemnities/" + updatedIndemnity.uuid;
        let response = await this.baseRequest("PUT", url, updatedIndemnity);
        if (response != null) {
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
    async uploadIndemnity(file, uuid) {
        let array = [];
        array.push(file);
        let formData = new FormData();
        let url = this.baseUrl + "indemnities/file/" + uuid;
        formData.append("fileToUpload", file);
        try {
            let response = await fetch(url, {
                method: "POST",
                headers: {
                    "X-Api-Key": this.currentToken,
                },
                body: formData
            });
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        catch (e) {
            console.error(e);
            return new RepositoryResponse(false, 400, null, null, null);
        }
    }
    async deleteIndemnity(indemnityUuid) {
        let url = "indemnities/" + indemnityUuid;
        let response = await this.baseRequest("DELETE", url);
        if (response != null) {
            let jsonResponse = await response.json();
            return jsonResponse;
        }
        else {
            return new RepositoryResponse(false, this.fetchErrorCode, null, null, null);
        }
    }
}
